export default "/fonts/Muli-Light.ttf?aade01402633f3b0d4f179eb118f887d";